import styled from 'styled-components';
import { DisableSelection } from '../../styles/stylesStyled';

const SearchContainer = styled.div<{ close: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 55px;
  background: ${(props) => props.theme.helpdesk.inputBackground};
  padding: 12px 16px 12px 20px;
  border-radius: 8px;
  img {
    margin-right: 15px;
    margin-left: 23px;
  }
  @media (max-width: 800px) {
    display: ${(props) => (props.close ? 'none' : 'flex')};
  }
`;

const SearchInput = styled.input`
  width: 100%;
  border: none;
  background: none;
  outline: none;
  font-size: 15px;
  z-index: 1;
  color: ${(props) => props.theme.helpdesk.fontColor};
`;

const HelpDeskContainer = styled.div<{ close: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  @media (max-width: 800px) {
    display: ${(props) => (props.close ? 'none' : 'flex')};
    flex-direction: column-reverse;
  }
`;

const TableContent = styled.div`
  width: 356px;
  background: ${(props) => props.theme.helpdesk.navBackground};
  border-radius: 22px;
  padding: 40px 40px 48px 40px;
  margin-bottom: 32px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const ContentTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 30px;
`;

const Content = styled.p<{ selected: boolean }>`
  cursor: pointer;
  margin-bottom: 16px;
  color: ${({ selected, theme }) =>
    selected ? theme.colors.neutral900 : theme.helpdesk.navFontColor};
`;

const TopicCategory = styled.div`
  /* padding-top: 20px; */
  color: ${(props) => props.theme.helpdesk.fontColor};

  li {
    color: ${(props) => props.theme.colors.neutral0};
    margin: 20px 0;
    cursor: pointer;
  }
`;

const TopicCategoryTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.neutral0};
  margin-bottom: 36px;
  img {
    margin-right: 32px;
  }
`;

const TopicCategorySubTitle = styled.div`
  color: #fefefe;
  font-size: 22px;
  font-weight: 700;
`;

const BreadCrumbsList = styled.ul`
  padding: 10px 16px;
  list-style: none;
`;

const BreadCrumbs = styled.div`
  font-size: 15px;
  color: ${(props) => props.theme.colors.neutral0};
  margin-bottom: 20px;
  display: flex;
  div {
    margin-right: 15px;
  }
`;

export const HelpdeskSendContainer = styled.div`
  width: 100%;
  max-width: 420px;
  @media (max-width: 800px) {
    max-width: 100%;
  }
`;

export const Select = styled.div<{ isOpen: boolean }>`
  > * {
    ${DisableSelection}
  }

  cursor: pointer;
  margin-bottom: 20px;
  width: 100%;
  /* padding: 1px; */
  background: ${(props) => (props.isOpen ? '#C6BDBD' : '#C6BDBD')};
  border-radius: 8px;
  position: relative;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    font-size: ${(props) => props.theme.inputFontSize};
    line-height: 20px;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.inputFontColor};
    border-radius: 8px;
    padding: 0 16px;
    background: ${(props) => props.theme.inputBackground};

    span {
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
`;

export const SelectDropDown = styled.div`
  width: 100%;
  font-size: ${(props) => props.theme.inputFontSize};
  /* line-height: 20px; */
  color: ${(props) => props.theme.inputFontColor};
  border-radius: 8px;
  padding: 0 18px;
  background: ${(props) => props.theme.inputBackground};
  max-height: 30vh;
  overflow: auto;

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    :hover {
      color: ${(props) => props.theme.colors.primary900} !important;
    }
  }
`;

export const CollapsableAbsolute = styled.div<{ isOpen: boolean }>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  max-height: ${(props) => (props.isOpen ? `30vh` : '0')};
  overflow: hidden;
  transition: all 300ms;
  margin-bottom: ${(props) => (props.isOpen ? '20px' : '0')};
  position: absolute;
  right: 0;
  left: 0;
  top: 76px;
  z-index: 1;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.helpdesk.fontColor};
  margin-bottom: 8px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  color: ${(props) => props.theme.helpdesk.fontColor};
  margin-bottom: 12px;
  margin-top: 40px;
  @media (max-width: 800px) {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }
`;

export const SubTitle = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: ${(props) => props.theme.helpdesk.fontColor};
  margin-bottom: 40px;
  @media (max-width: 800px) {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #b5a8a8;
  }
`;

export const FileUpload = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.inputBackground};
  /* border: 1px dashed #fffbfa; */
  box-sizing: border-box;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: ${(props) => props.theme.inputFontColor};
  span {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.01em;
    color: ${(props) => props.theme.inputFileUploadRestrictionsText};
    margin-bottom: 20px;
  }
  img {
    height: 100%;
    width: 100%;
  }
`;

export const Browse = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #fffbfa;
  border: 1px solid #fefefe;
  border-radius: 8px;
  padding: 8px 17px;
`;

export const SearchDropdownStyle = styled.div`
  color: ${(props) => props.theme.helpdesk.fontColor};
  background-color: ${(props) => props.theme.helpdesk.inputBackground};
  border-radius: 8px;
  padding: 20px;
  padding-bottom: 5px;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 999;
  max-height: 500px;
  overflow: auto;
`;

export const SearchDropdownQuestion = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
`;

export {
  SearchContainer,
  SearchInput,
  HelpDeskContainer,
  TableContent,
  ContentTitle,
  Content,
  TopicCategory,
  TopicCategoryTitle,
  TopicCategorySubTitle,
  BreadCrumbsList,
  BreadCrumbs
};
